import { call, select } from 'redux-saga/effects';
import { broadcastPermissionGranted } from 'features/permissions/actions';
import { changeRole, selectLocalUserId } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { preloadVirtualBackgroundSaga } from 'features/virtual-backgrounds/sagas/preloadVirtualBackgroundSaga';

// `changeRole` is needed alongside `broadcastPermissionGranted`: an audio-broadcast role
// upgraded to a video-broadcast role emits no grant (handleRoleChangeBroadcastPermissionsSaga
// diffs access with mode 'any'). Its reducer runs before takers, so the new role is settled here.
export function* preloadVirtualBackgroundOnPermissionsChangedSaga({
  payload,
}: ReturnType<typeof broadcastPermissionGranted> | ReturnType<typeof changeRole>) {
  const localUserId: UserId = yield select(selectLocalUserId);
  // The grant's `payload.video` is `!isAudioOnlyRoom` rather than a permission —
  // preloadVirtualBackgroundSaga re-reads the real one.
  if (payload.id !== localUserId) {
    return;
  }

  yield call(preloadVirtualBackgroundSaga);
}
